import { render, staticRenderFns } from "./TimeclockOperatorNumberAssignmentDialog.vue?vue&type=template&id=639493a4&"
import script from "./TimeclockOperatorNumberAssignmentDialog.vue?vue&type=script&lang=ts&"
export * from "./TimeclockOperatorNumberAssignmentDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports